import { render, staticRenderFns } from "./HelpInfo.vue?vue&type=template&id=15c98c06&scoped=true&"
import script from "./HelpInfo.vue?vue&type=script&lang=js&"
export * from "./HelpInfo.vue?vue&type=script&lang=js&"
import style0 from "./HelpInfo.vue?vue&type=style&index=0&id=15c98c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c98c06",
  null
  
)

export default component.exports